import { Logos } from "@/libraries/design/patterns";

import { UniformLogo, flattenLogoProps } from "../../../contenttypes/logo";

export interface UniformLogosProps {
    title?: string;
    tagType?: "h2" | "h3" | "h4";
    logos: UniformLogo[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformLogos = (intakeProps: any) => {
    const { title, tagType, logos }: UniformLogosProps =
        flattenLogoProps(intakeProps);
    return <Logos title={title} tagType={tagType} logos={logos} />;
};

export default UniformLogos;
